var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQriosLogoColor = function SvgQriosLogoColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.33 128.33"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".qriosLogoColor_svg__cls-1{fill:none;stroke:#ff61d6;stroke-miterlimit:10;stroke-width:.25px}"))), /*#__PURE__*/React.createElement("g", {
    id: "qriosLogoColor_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qriosLogoColor_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "qriosLogoColor_svg__cls-1",
    d: "M97.15 31.18a46.65 46.65 0 1 0 0 66 46.64 46.64 0 0 0 0-66Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "qriosLogoColor_svg__cls-1",
    cx: 15.18,
    cy: 90.31,
    r: 8.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.54 18.79a64.17 64.17 0 1 0 0 90.75 64.19 64.19 0 0 0 0-90.75Zm-20 48.6H52.93a17.31 17.31 0 1 1-15.13-7.25h37.6a17.3 17.3 0 1 1 14.11 7.3Z",
    style: {
      fill: "#00683e"
    }
  }))));
};
export { SvgQriosLogoColor as ReactComponent };
export default __webpack_public_path__ + "c76ae23e49269d0a2ae1474f2946f3bf.svg";